import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Materialize from 'materialize-css/dist/js/materialize.min.js';

const ProductList = (props) => {    
    useEffect(() => {
        Materialize.AutoInit();
    },[]);

     /* Defactor data from props */
     const { data } = props;
     console.log('products',data);
     const products = data ? (
        data.map(product => {
             return(
                <tr className="list" key={product.id}>                            
                    <td>{product.sku}</td>
                    <td>{product.name}</td>
                    <td>{product.description}</td>
                    <td><Link to={'/pro/' + product.id} ><i className="material-icons grey-text text-darken-3">edit</i></Link></td>
                </tr>
             );                                
         }) 
     ) : null;
    return ( 
        <div className="table-overflow">
            <table className=" highlight">
                <thead>
                    <tr>
                        <th data-field="id">SKU</th>
                        <th data-field="name">Name</th>
                        <th data-field="description">Description</th>
                        <th data-field="edit" className="icon-head"></th>
                    </tr>
                </thead>

                <tbody>
                    {products}
                </tbody>
            </table>
        </div>        
     );
}
 
export default ProductList;